export default "/_next/static/images/membershipAdBg-2f8f1ff1e593c57aa2a7e561432e911c.png";